import { useMutation } from '@tanstack/react-query';
import axiosUtils from 'utils/axiosUtils';

import ERROR_MESSAGE from 'constants/errorMessage';
import handleErrorMessageAPI from 'global/AlertErrorMessage';

import { postApplyReferral } from 'lib/api/community';

function useJoinCommunity() {
  const mutation = useMutation({
    mutationFn: async (code: string) => {
      const response = await postApplyReferral(code);
      if (!response.data) {
        throw new Error(
          'Something is terribly wrong, please contact our administrator',
        );
      }
      const { data } = response.data;
      return data;
    },
    retry: false,
  });

  return mutation;
}

export default useJoinCommunity;
